export const USER_ROLES = {
    admin: 'admin_role',
    public: 'public_role',
} as const;
